// this works better as a js file with no type definitions
// because it's generated and it's just a bunch of strings,
// so we have a postbuild script that just copies the esm
// build to index.d.ts and it works great.
var black = "#000000";
var white = "#ffffff";
var transparent = "rgba(0, 0, 0, 0)";
var blue100 = "#f5fbfe";
var blue200 = "#e4f1fb";
var blue300 = "#bfdbee";
var blue400 = "#50c7f9";
var blue500 = "#009cde";
var blue600 = "#0070ba";
var blue700 = "#005ea6";
var blue800 = "#003087";
var grey100 = "#f5f7fa";
var grey200 = "#eaeced";
var grey300 = "#cbd2d6";
var grey400 = "#b7bcbf";
var grey500 = "#9da3a6";
var grey600 = "#687173";
var grey700 = "#2c2e2f";
var green100 = "#f5fdfb";
var green500 = "#00cf92";
var green600 = "#299976";
var green700 = "#018065";
var red100 = "#fff7f7";
var red500 = "#d20000";
var orange100 = "#fffbf5";
var orange300 = "#ffbd5d";
var orange500 = "#ff9600";
var orange700 = "#d64003";
var purple500 = "#640487";
var pink500 = "#de0063";
var borderform = "#909697";
var error = "#d20000";
var success = "#299976";
var backgroundselected = "#0070ba";
var iconlink = "#0070ba";
var textsupporting = "#687173";
var textform = "#000000";
var textprimary = "#2c2e2f";
var textlink = "#0070ba";
var v2neutral100 = "#f7f5f0";
var v2neutral200 = "#f1efea";
var v2neutral300 = "#dbd8d0";
var v2white = "#ffffff";
var v2grey50 = "#fafafa";
var v2grey300 = "#acadad";
var v2grey400 = "#909191";
var v2grey500 = "#757676";
var v2grey600 = "#515354";
var v2black = "#0c0c0d";
var v2blue100 = "#d1f1ff";
var v2blue200 = "#9ee0fe";
var v2blue300 = "#56ccfe";
var v2blue400 = "#1072eb";
var v2blue500 = "#1040c1";
var v2blue600 = "#142c8e";
var v2blue700 = "#121661";
var v2gold = "#ffc43a";
var v2magenta100 = "#ffcfef";
var v2magenta200 = "#f589d0";
var v2magenta300 = "#e557b4";
var v2magenta400 = "#c73193";
var v2magenta500 = "#9c2874";
var v2magenta600 = "#6c1b50";
var v2orange100 = "#fddbd3";
var v2orange200 = "#f9967b";
var v2orange300 = "#f55e36";
var v2orange400 = "#d9360b";
var v2orange500 = "#ad2b09";
var v2orange600 = "#791e06";
var v2green100 = "#cbf3ec";
var v2green200 = "#69d5ba";
var v2green300 = "#38af88";
var v2green400 = "#308a67";
var v2green500 = "#25694f";
var v2green600 = "#184634";
var v2yellow100 = "#fff1a7";
var v2yellow200 = "#ffe350";
var v2yellow300 = "#fed13c";
var v2yellow400 = "#ffc43a";
var v2yellow500 = "#d89700";
var v2yellow600 = "#785504";
var v2purple100 = "#f2e6fe";
var v2purple200 = "#e1c2ff";
var v2purple300 = "#c089f7";
var v2purple400 = "#a250f5";
var v2purple500 = "#761ad3";
var v2purple600 = "#5b06b0";
var v2illustrationblack = "#222324";
var v2skin100 = "#ffe2d3";
var v2skin200 = "#fdd9b3";
var v2skin300 = "#e9c196";
var v2skin400 = "#dda97d";
var v2skin500 = "#c58c5f";
var v2skin600 = "#a26033";
var v2skin700 = "#73422f";
var v2skin800 = "#4f3631";
var v2shadowscrimblack = "#000000";

export { backgroundselected, black, blue100, blue200, blue300, blue400, blue500, blue600, blue700, blue800, borderform, error, green100, green500, green600, green700, grey100, grey200, grey300, grey400, grey500, grey600, grey700, iconlink, orange100, orange300, orange500, orange700, pink500, purple500, red100, red500, success, textform, textlink, textprimary, textsupporting, transparent, v2black, v2blue100, v2blue200, v2blue300, v2blue400, v2blue500, v2blue600, v2blue700, v2gold, v2green100, v2green200, v2green300, v2green400, v2green500, v2green600, v2grey300, v2grey400, v2grey50, v2grey500, v2grey600, v2illustrationblack, v2magenta100, v2magenta200, v2magenta300, v2magenta400, v2magenta500, v2magenta600, v2neutral100, v2neutral200, v2neutral300, v2orange100, v2orange200, v2orange300, v2orange400, v2orange500, v2orange600, v2purple100, v2purple200, v2purple300, v2purple400, v2purple500, v2purple600, v2shadowscrimblack, v2skin100, v2skin200, v2skin300, v2skin400, v2skin500, v2skin600, v2skin700, v2skin800, v2white, v2yellow100, v2yellow200, v2yellow300, v2yellow400, v2yellow500, v2yellow600, white };
